import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoginManager } from '../../core/login-manager';
import { refId, refLabel } from '../../lib/format';
import { isAdminGlobale } from '../../lib/ruoli';
import { useEntityList, SectionHead, statoLista, OpenLink } from './common';

/**
 * Anagrafica immobiliare del condominio: le palazzine.
 *
 * Gli appartamenti stanno dentro la pagina della loro palazzina: e' li' che
 * appartengono, e cosi' non serve piu' sceglierla a ogni inserimento.
 *
 * L'amministratore globale le vede tutte, di ogni condominio: senza la colonna
 * del condominio due "Palazzina A" sarebbero indistinguibili.
 */
export default function Anagrafiche() {
    const [userInfo] = useState(() => LoginManager.getUserInfo());
    const globale = isAdminGlobale(userInfo);

    const { items, loading, error, reload } = useEntityList('palazzina', 'nome', 'asc');
    const appartamenti = useEntityList('appartamento', 'identificativo', 'asc');

    const stato = statoLista({
        loading: loading,
        error: error,
        empty: items.length === 0,
        icon: 'building',
        message: 'Nessuna palazzina: senza anagrafica i condomini non hanno un’unità da associare.',
        onRetry: reload
    });

    return (
        <section className="lv-card lv-card-pad">
            <SectionHead
                eyebrow="Anagrafica immobiliare"
                title="Palazzine e appartamenti"
                subtitle="Le palazzine del condominio e i loro appartamenti, da assegnare ai condomini."
                action={
                    <Link to="/admin/anagrafiche/nuova" className="lv-btn lv-btn-primary lv-btn-pill">
                        <FontAwesomeIcon icon={['fas', 'plus']} />
                        Nuova palazzina
                    </Link>
                }
            />

            {stato || (
                <div className="lv-table-wrap">
                    <table className="lv-table">
                        <thead>
                            <tr>
                                <th>Palazzina</th>
                                {globale && <th>Condominio</th>}
                                <th>Indirizzo</th>
                                <th>Appartamenti</th>
                                <th>Azioni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map(p => {
                                const n = appartamenti.items.filter(a => refId(a.idPalazzina) === p.id).length;
                                return (
                                    <tr key={p.id}>
                                        <td data-label="Palazzina">
                                            <div className="lv-cell-strong">{p.nome}</div>
                                            {p.note && <div className="lv-cell-sub">{p.note}</div>}
                                        </td>
                                        {globale && (
                                            <td data-label="Condominio">
                                                {refLabel(p.idUserGroup, ['name'], 'Da assegnare')}
                                            </td>
                                        )}
                                        <td data-label="Indirizzo">{p.indirizzo || '—'}</td>
                                        <td data-label="Appartamenti">
                                            {n === 0 ? 'Nessuno' : `${n} appartamenti`}
                                        </td>
                                        <td data-label="Azioni">
                                            <div className="lv-row-actions">
                                                <OpenLink to={`/admin/anagrafiche/${p.id}`} />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
}
